import axios from "axios";

const API = "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (value, currency = "INR") => {
  const rate = currency === "USD" ? 1 / 83 : 1;
  return new Intl.NumberFormat(currency === "INR" ? "en-IN" : "en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format((value || 0) * rate);
};

export const shortDate = (value) => {
  if (!value) return "—";
  const hasTime = typeof value === "string" && value.length > 10;
  const d = hasTime ? new Date(value) : new Date(`${String(value).slice(0, 10)}T00:00:00Z`);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });
};

// Today's date in IST (Asia/Kolkata) as YYYY-MM-DD, with optional day offset.
export const istToday = (offsetDays = 0) =>
  new Date(Date.now() + offsetDays * 86400000).toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export const statusClass = (status = "") => status.toLowerCase().replace(/\s+/g, "-");
